import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List } from 'immutable'
import _ from 'lodash'

import SelectSupplierOrder from '../../components/selectSupplierOrder'

import actions from '../../redux/suppliers/actions'

const { fetchSupplierOrders } = actions

const VALUE_FROM_STATE = 'VALUE_FROM_STATE'

class SelectSupplierOrderByOrderContainer extends Component {
    static propTypes = {
        // Props from another component
        onChange: PropTypes.func,
        orderId: PropTypes.string.isRequired,
        value: PropTypes.string,

        // Inner props
        fetchSupplierOrders: PropTypes.func.isRequired,
        supplierOrderEntities: ImmutablePropTypes.map.isRequired,
        suppliers: ImmutablePropTypes.map.isRequired
    }

    static defaultProps = {
        onChange: () => {},
        value: undefined
    }
    constructor (props) {
        super(props)

        this.state = {
            value: props.value === VALUE_FROM_STATE ? undefined : props.value
        }
    }

    componentDidMount () {
        const { fetchSupplierOrders, orderId } = this.props

        if (!orderId) return null
        fetchSupplierOrders(orderId)
    }

    componentDidUpdate (prevProps) {
        const { orderId: prevOrderId } = prevProps
        const { orderId: currOrderId, fetchSupplierOrders } = this.props

        if (_.isEqual(prevOrderId, currOrderId)) return null

        fetchSupplierOrders(currOrderId)
    }

    getSupplierOrders () {
        const { suppliers, supplierOrderEntities } = this.props
        return suppliers.get('supplierOrders', new List()).map((supplierOrderId) => {
            return supplierOrderEntities.get(_.toString(supplierOrderId))
        })
    }

    onChange = (supplierOrderId) => {
        const { onChange } = this.props

        onChange(supplierOrderId)
        this.setState({ value: supplierOrderId })
    }

    render () {
        const { suppliers, value: propValue, ...restProps } = this.props
        const { value: stateValue } = this.state

        const value = propValue === VALUE_FROM_STATE ? stateValue : propValue

        return (
            <SelectSupplierOrder
                value={value}
                loading={suppliers.get('supplierOrdersLoading')}
                onChange={this.onChange}
                supplierOrders={this.getSupplierOrders().toJS()}
                {...restProps}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        supplierOrderEntities: state.getIn(['Entities', 'supplierOrders']),
        suppliers: state.get('suppliers')
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchSupplierOrders
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectSupplierOrderByOrderContainer)
